// extracted by mini-css-extract-plugin
export default {"menuBlock":"VE-z","title":"WE-z","nav":"XE-z","flexCell":"YE-z","facetLink":"ZE-z"};